export const Products = {
  MINISTRY_INSIGHTS: 'MINISTRY_INSIGHTS',
  CMS: 'CMS',
  CRM: 'CRM',
  WORKFLOW_AI: 'WORKFLOW_AI',
  AI_TRANSLATIONS: 'AI_TRANSLATIONS',
  AI_AUDIO_BOOKS: 'AI_AUDIO_BOOKS',
  SOCIAL_CLIPS: 'SOCIAL_CLIPS',
  PRAYSTUDIO: 'PRAYSTUDIO',
} as const;

export const PRODUCT_LABELS = {
  [Products.MINISTRY_INSIGHTS]: 'Ministry Insights',
  [Products.CMS]: 'CMS',
  [Products.CRM]: 'CRM',
  [Products.WORKFLOW_AI]: 'Workflow AI',
  [Products.AI_TRANSLATIONS]: 'AI Translations',
  [Products.AI_AUDIO_BOOKS]: 'AI Audio Books',
  [Products.SOCIAL_CLIPS]: 'Social Clips',
  [Products.PRAYSTUDIO]: 'PRAYStudio',
};
